import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Dialog } from './../../container/dialog';
import { ApiService } from '@usimweb/core/services';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'news-dialog',
  templateUrl: './news-dialog.component.html',
  styleUrls: ['./news-dialog.component.scss'],
  standalone: false,
})
export class NewsDialogComponent extends Dialog implements OnInit {
  @Input() data: any;

  public content: any;
  public imageSource: any;

  constructor(
    private dialogRef: MatDialogRef<NewsDialogComponent>,
    private apiService: ApiService,
    private domiSanitier: DomSanitizer
  ) {
    super();
  }

  ngOnInit(): void {
    this.content = this.domiSanitier.bypassSecurityTrustHtml(this.data.content);
    this.imageSource = this.data.png;
  }

  public save() {
    this.dialogRef.close(this.data);
  }

  public close() {
    this.dialogRef.close();
  }

  public toggleRead() {
    this.apiService.toggleNews(this.data.uuid).subscribe();
  }
}
